import { Staff } from '../../lib/types/models/staff/staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const reactivateStaff = (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.staffs.reactivate.url, { id }))
    .post<Staff, number>()
}
